import { get } from "lodash";
import styles from "./PriceBox.module.scss";
import Price from "grandus-lib/components-atomic/price/Price";

const PriceBox = ({ product }) => {
  return (
    <div className={styles?.wrapper}>
      {product?.discount ? (
        <div className={styles.save}>
          <span>Šetrenie:</span>
          <span>{product.discount}</span>
        </div>
      ) : (
        ""
      )}
      <div className={styles.prices}>
        {product?.standardPriceData?.price ? (
          <div className={styles.mainPrice}>
            <span>Pôvodná cena:</span>
            <span style={{textDecoration: 'line-through'}}>{get(product, "standardPriceData.priceFormatted")}</span>
          </div>
        ) : (
          ""
        )}

        <div className={styles.discountPrice}>
          <span>U nás:</span>
          <Price
            priceData={
              product?.specialPrice
                ? get(product, "specialPrice.priceData")
                : get(product, "finalPriceData")
            }
          />
        </div>
      </div>
    </div>
  );
};

export default PriceBox;
